<template>
  <Page
    title="Invite a Global Admin User"
    subtitle="Copy this link and send to your Global Administrator to complete the connection
"
    :hasBack="true"
  >
    <div class="w-full flex flex-col items-center justify-center">
      <div
        class="flex flex-row justify-center items-center bg-light border border-main-3 px-4 py-4 rounded-md w-full mb-5"
      >
        <p class="text-gray-600 text-lg">{{ inviteLink }}</p>
      </div>

      <AppButton text="Copy link" class="bg-dark" @click="copyLink">
        <svg
          class="w-6 h-6 text-white mr-3 -ml-3"
          width="28"
          height="24"
          viewBox="0 0 28 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M26.4634 2.03533C25.478 1.05087 24.1408 0.500046 22.7507 0.500046C21.3607 0.494186 20.0235 1.05087 19.0381 2.03533L12.2639 8.80935C10.9208 10.1513 10.4106 12.1143 10.9208 13.9367C11.0733 14.47 11.6246 14.7806 12.1584 14.6282C12.6921 14.4758 13.0029 13.925 12.8504 13.3918C12.5337 12.2608 12.8504 11.0537 13.6774 10.2216L20.4575 3.44756C21.7243 2.18183 23.7771 2.18183 25.0499 3.44756C26.3167 4.71329 26.3167 6.76425 25.0499 8.03584L18.2698 14.8099C17.8241 15.2552 17.261 15.5599 16.6452 15.6888C16.1056 15.8002 15.7537 16.3334 15.871 16.8725C15.9707 17.3355 16.3812 17.6695 16.8563 17.6695C16.9267 17.6695 16.9971 17.6636 17.0616 17.646C18.0587 17.4351 18.9677 16.9428 19.6833 16.2221L26.4634 9.44807C28.5103 7.40298 28.5103 4.08629 26.4634 2.03533Z"
              fill="currentColor"
            />
            <path
              d="M17.0499 10.0925C16.8974 9.55922 16.346 9.24865 15.8123 9.40101C15.2786 9.55336 14.9677 10.1042 15.1202 10.6374C15.4369 11.7684 15.1202 12.9755 14.2933 13.8076L7.51319 20.5816C6.24633 21.8474 4.19354 21.8474 2.92082 20.5816C1.65395 19.3159 1.65395 17.265 2.92082 15.9934L9.70088 9.21935C10.1466 8.774 10.7097 8.46929 11.3196 8.34037C11.8592 8.23489 12.2111 7.70751 12.1056 7.16254C12 6.61757 11.4721 6.27184 10.9267 6.37731C10.9208 6.37731 10.915 6.37731 10.9091 6.38317C9.91202 6.59413 9.00293 7.08636 8.28739 7.80712L1.50733 14.5811C-0.527865 16.6438 -0.498539 19.9664 1.56598 21.9939C3.60703 24.0038 6.88563 24.0038 8.93255 21.9939L15.7126 15.2199C17.0499 13.878 17.5601 11.9208 17.0499 10.0925Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="28"
                height="23"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </AppButton>
      <transition name="fade-up">
        <div
          v-if="showClipboardMsg"
          class="absolute bottom-0 flex flex-row px-6 py-2 shadow-sm"
          style="background: #4caf4f41"
        >
          <p class="text-level-l text-lg">Link was copied to the clipboard</p>
        </div>
      </transition>
    </div>
  </Page>
</template>

<script>
import Page from "@/components/Page.vue";
import { env } from "../env";
import { state } from "@/state";
import { AppAnalytics } from "@/analytics";
export default {
  components: {
    Page
  },
  data() {
    return {
      showClipboardMsg: false,
      inviteLink: ""
    };
  },
  async mounted() {
    const { globalAdminLink } = await env();
    const { email, partnerId } = state.getSession();
    console.log("from session : ", email, partnerId);
    this.inviteLink = `${location.host}/global-admin?from=${email}&partnerId=${partnerId}`;
  },
  methods: {
    copyLink() {
      AppAnalytics.report({
        eventName: "Onboarding_not a global admin_click on copy link"
      });
      const el = document.createElement("textarea");
      el.value = this.inviteLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.showClipboardMsg = true;
      setTimeout(() => {
        this.showClipboardMsg = false;
      }, 3000);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-up-enter-active {
  animation: fadeUp 300ms ease-in;
}

.fade-up-leave-active {
  animation: fadeUp 300ms ease-in reverse;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
